module.exports = __webpack_public_path__ + "images/smartorg_logo_transparent.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/smartorg_logo_transparent.png
// module id = 69
// module chunks = 0